import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as types from './mutation-types'

Vue.use(Vuex)

const mutations = {
    [types.SET_ANSWER](state, ans) {
        let res = state.answers.find((a) => {
            return a.question == ans.question
        })

        if (res !== undefined) {
            state.answers.splice(state.answers.indexOf(res), 1)
        }

        state.answers.push(ans)
    },
    [types.SET_ANNEX](state, ans) {
        let res = state.annexes.find((a) => {
            return a.annex == ans.annex
        })

        if (res !== undefined) {
            state.annexes.splice(state.annexes.indexOf(res), 1)
        }

        state.annexes.push({
            annex: ans.annex,
            answers: ans.answers
        })
    },
    [types.CLEAR_ANSWERS](state) {
        state.answers = []
    },
    [types.CLEAR_ANNEXES](state) {
        state.annexes = []
    },
    [types.SET_USER](state, { usuarioid, nombre, email, position }) {
        state.user = {
            usuarioid: usuarioid,
            nombre: nombre,
            email: email,
            position: position
        }
    },
    [types.SET_EVALUATION](state, eva) {
        state.evaluation = eva
    },
}

const state = {
    answers: [],
    annexes: [],
    evaluation: [],
    user: {
        usuarioid: null,
        nombre: null,
        email: null,
        position: null
    }
}

const getters = {
    getAnswers: state => state.answers,
    getAnnexes: state => state.annexes,
    getUser: state => state.user,
    getEvaluation: state => state.evaluation
}

const actions = {
    setAnswer({ commit }, data) {
        commit(types.SET_ANSWER, data);
    },
    setAnnex({ commit }, data) {
        commit(types.SET_ANNEX, data);
    },
    clearAnswers({ commit }) {
        commit(types.CLEAR_ANSWERS)
    },
    clearAnnexes({ commit }) {
        commit(types.CLEAR_ANNEXES)
    },
    setUser({ commit }, data) {
        commit(types.SET_USER, {
            usuarioid: data.usuarioid,
            nombre: data.nombre,
            email: data.email,
            position: data.company
        });
    },
    setEvaluation({ commit }, data) {
        commit(types.SET_EVALUATION, data);
    }
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins: [createPersistedState()]
})
